export function urlToPattern(
  url: string | undefined,
  fallbackPattern = ".*"
): string {
  const trimmed = (url ?? "").trim().replace(/\/+$/, "");
  if (!trimmed) return fallbackPattern;

  const escaped = trimmed.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return `${escaped}/.*`;
}
